import React, { useEffect, useRef, useState } from "react";
import {FacebookIcon, TwitterIcon, PlusIcon} from "gatsby-theme-jqi";
import PrinterIcon from "../../icons/printer.svg";

import "./SocialShare.scss";

const SocialShare: React.FC = () => {
  const shareRef = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const script = document.createElement("SCRIPT") as HTMLScriptElement;
    script.src = "https://static.addtoany.com/menu/page.js";
    script.async = true;
    script.addEventListener('load', () => setLoaded(true));
    shareRef.current?.appendChild(script);
  }, []);
  useEffect(() => {
    if (!loaded) return
    if (window.a2a) {
      window.a2a.init_all();
    }
  }, [loaded]);
  return (
    <div className="social-share print:hidden" ref={shareRef}>
    { loaded &&
      <div className="a2a_kit a2a_kit_size_32 a2a_default_style social-share__buttons a2a_flex_style" data-a2a-icon-color="#E21833,white">
        <a className="a2a_button_facebook social-share__button">
          <FacebookIcon className="icon icon-facebook" aria-hidden="true" width="14" height="22" />
        </a>
        <a className="a2a_button_x social-share__button">
          <TwitterIcon className="icon icon-twitter" aria-hidden="true" width="23" height="19" />
        </a>
        <a className="a2a_button_print social-share__button">
          <PrinterIcon className="icon icon-printer" aria-hidden="true" width="20" height="18" />
        </a>
        <a className="a2a_dd social-share__button">
          <PlusIcon className="icon icon-plus" aria-hidden="true" width="16" height="16" />
        </a>
      </div>
    }
    </div>
  )
};

export default SocialShare;
